import React from "react";

const Stat_Mean = () => {
  return (
    <div>
      <h1>Stat Mean</h1>
    </div>
  );
};

export default Stat_Mean;
